import { Plan, PlanPrice, CorePlanTier } from "../types";

export const CORE_PLAN_TIERS: CorePlanTier[] = [
    {
        credits: 15,
        monthlyPrice: 99,
        annualPrice: 79,
        monthlyDiscountPercent: 0,
        annualDiscountPercent: 0
    },
    {
        credits: 50,
        monthlyPrice: 229,
        annualPrice: 199,
        monthlyDiscountPercent: 8,
        annualDiscountPercent: 15,
        isDefault: true
    },
    {
        credits: 100,
        monthlyPrice: 399,
        annualPrice: 359,
        monthlyDiscountPercent: 12,
        annualDiscountPercent: 18
    },
    {
        credits: 200,
        monthlyPrice: 729,
        annualPrice: 669,
        monthlyDiscountPercent: 15,
        annualDiscountPercent: 20
    }
];

const defaultCoreTier = CORE_PLAN_TIERS.find((t) => t.isDefault) || CORE_PLAN_TIERS[0];

export const PLAN_PRICING: Record<Plan, PlanPrice> = {
    [Plan.Public]: { monthly: "Free", annual: "Free" },
    [Plan.UbpBasic]: { monthly: 65, annual: 49 },
    [Plan.UbpCore]: { monthly: defaultCoreTier.monthlyPrice, annual: defaultCoreTier.annualPrice },
    [Plan.UbpGrowth]: { monthly: 399, annual: 299 },
    [Plan.UbpPremiumTrial]: { monthly: 399, annual: 299 },
    [Plan.EnterpriseGrowth]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.Enterprise]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.LegacySandbox]: { monthly: "Free", annual: "Free" },
    [Plan.LegacyStarter]: { monthly: 249, annual: 200 },
    [Plan.Research]: { monthly: "Free", annual: "Free" },
    [Plan.UninitalizedWorkspace]: { monthly: "N/A", annual: "N/A" }
} as any;
